'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';
import { useMount, useUnmount } from 'react-use';

import Script from 'next/script';

const Peek = () => {
    const [isInitialize, setInitialize] = useState(false);
    useMount(() => {
        if (!window.PeekJsApi) {
            setInitialize(true);
        }
    });

    useUnmount(() => {});

    return (
        isInitialize && (
            <Script id="peek-loader">{`
     (function(config) {
    window._peekConfig = config || {};
    var idPrefix = 'peek-book-button';
    var id = idPrefix+'-js'; if (document.getElementById(id)) return;
    var head = document.getElementsByTagName('head')[0];
    var el = document.createElement('script'); el.id = id;
    var date = new Date; var stamp = date.getMonth()+"-"+date.getDate();
    var basePath = "https://js.peek.com";
    el.src = basePath + "/widget_button.js?ts="+stamp;
    head.appendChild(el); id = idPrefix+'-css'; el = document.createElement('link'); el.id = id;
    el.href = basePath + "/widget_button.css?ts="+stamp;
    el.rel="stylesheet"; el.type="text/css"; head.appendChild(el);
  })({key: '2bcea190-2277-4422-8876-afa9234a6c9d'});
            `}</Script>
        )
    );
};

Peek.propTypes = {};

export default Peek;
